import React, { forwardRef } from 'react'
import { Container, HelperText, Label, SelectField, Wrapper } from './Select.styles'

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement>{
  label?: string;
  colorLabel?: string;
  colorText?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  options: { value: string | number | undefined, label: string }[];
  onChange?: React.ChangeEventHandler<HTMLSelectElement>
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  className,
  helperText,
  disabled,
  error,
  options,
  colorLabel,
  colorText,
  onChange,
  ...props
}, ref) => {
  return (
    <Container>
      {!!label && <Label color={colorLabel}>{label}</Label>}
      <Wrapper>
        <SelectField
          ref={ref}
          disabled={disabled}
          className={className}
          $colorText={colorText}
          onChange={onChange}
          {...props}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </SelectField>
      </Wrapper>
      {!!helperText && (
        <HelperText style={{ color: !error ? "#64748B" : "#F3322B" }}>
          {helperText}
        </HelperText>
      )}
    </Container>
  )
})
